import React from "react";
import Joyride, { LIFECYCLE, ACTIONS, EVENTS, CallBackProps } from "react-joyride";
import { useState } from "react";
import { getJoyrideSteps } from "./joyrideSteps";
import { handleJoyrideCallback } from "./joyrideCallbackHandler";

interface JoyrideWrapperProps {
    run: boolean | string;
    stepIndex?: number;
    setStepIndex?: (index: number) => void;
    goToStepHoc?: (direction: string) => void;
    booleanValue?: boolean;
    setRun?: (boolean: boolean) => void;
    setModalJoyride?: (boolean: boolean) => void;
    info?: any;
    mutationForOnlineRecord?: () => void;
    hasExistingSchedule?: boolean;
    hasExistingServices?: boolean;
}

const JoyrideWrapper: React.FC<JoyrideWrapperProps> = ({
    run,
    stepIndex,
    setStepIndex,
    goToStepHoc,
    booleanValue,
    setRun,
    setModalJoyride,
    info,
    mutationForOnlineRecord,
    hasExistingSchedule,
    hasExistingServices,
}) => {
    const [skipSteps, setSkipSteps] = useState(0);
    const goToStep = (direction: string | number) => {
        if (typeof direction === "number") {
            setStepIndex?.(direction);
            localStorage.setItem("step", direction.toString());
        } else {
            let newStepIndex = stepIndex;
            if (direction === "skip") {
                newStepIndex += 2;
                setSkipSteps((prev) => prev + 1);
            } else if (direction === "next") {
                newStepIndex += 1;
            } else if (direction === "back" && stepIndex > 0) {
                newStepIndex -= 1;
            }
            setStepIndex?.(newStepIndex);
            localStorage.setItem("step", newStepIndex.toString());
        }
    };
    const handleJoyrideCallbackWrapper = (data: CallBackProps) => {
        if (skipSteps > 0) {
            setSkipSteps((prev) => prev - 1);
            return;
        }
        handleJoyrideCallback(data, setStepIndex, mutationForOnlineRecord);
    };

    return (
        <Joyride
            steps={getJoyrideSteps({
                goToStep,
                booleanValue,
                setRun,
                setModalJoyride,
                info,
                hasExistingSchedule,
                hasExistingServices,
            })}
            run={run}
            stepIndex={stepIndex}
            continuous={true}
            scrollToFirstStep={true}
            showProgress={true}
            showSkipButton={true}
            spotlightClicks={true}
            callback={handleJoyrideCallbackWrapper}
            tooltipComponent={({ step }) => <div>{step.content}</div>}
            disableScrollParentFix={stepIndex !== 8}
        />
    );
};

export default JoyrideWrapper;
